import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { formValues } from 'redux-form'
import { get } from 'lodash'
import { Divider } from '@material-ui/core'
import Scrollbars from 'react-custom-scrollbars'
import Flex from 'typescript-styled-flex'
import SearchPopover from '../../../../components/Template/Search/SearchPopover'
import useSize from '../../../../hooks/useSize'
import styled, { ITheme } from '../../../../theme'
import { getClientsListSearch } from '../../../../reducers/clients/selectors'

const CHARACTERS_THRESHOLD = 3

function ClientSearch({ anchor, open, closePopper, setPhone }) {
  const size = useSize('forms')

  useEffect(() => {
    window.addEventListener('orientationchange', closePopper)
    return () => {
      window.removeEventListener('orientationchange', closePopper)
    }
  }, [closePopper])

  return (
    <>
      <SearchPopover
        style={{
          maxHeight: '41.3vh',
          userSelect: 'none',
        }}
        mouseEvent={'onMouseDown'}
        scaleToAnchor={true}
        size={size}
        popperOnMobile={true}
        open={open}
        onClose={closePopper}
        anchorRef={anchor}
        eventsEnabled={true}
        disablePortal={false}
        placement={'bottom-start'}
      >
        <ClientSearchList
          setPhone={setPhone}
          width={anchor.current && anchor.current.getBoundingClientRect()}
          closePopper={closePopper}
        />
      </SearchPopover>
    </>
  )
}

const ClientSearchList = formValues<{
  closePopper?: () => void
  'guest.name'?: string
  width?: number
  setPhone?: (e) => void
}>('guest.name')(props => {
  const clients = useSelector(getClientsListSearch)

  const dispatch = useDispatch()

  function onClick(client) {
    return () => {
      for (const [key, value] of Object.entries(client)) {
        dispatch(props['_reduxForm'].change(`guest.${key}`, value))
        if (key === 'phone') {
          props.setPhone({ target: { value: value } })
        }
      }
      props.closePopper()
    }
  }

  function renderClients() {
    if (
      !(
        props['guest.name'] &&
        String(props['guest.name']).length >= CHARACTERS_THRESHOLD
      )
    ) {
      return []
    }

    const lcguestname = props['guest.name'].toLowerCase()
    return clients
      .filter(client =>
        ['name', 'phone', 'city']
          .map(path => get(client, path, ''))
          .some(pathValue => {
            return pathValue
              .toString()
              .toLowerCase()
              .includes(lcguestname)
          }),
      )
      .map(client => (
        <ClientElement width={props.width} onClick={onClick} client={client}/>
      ))
  }

  if (renderClients() && renderClients().length > 0) {
    return (
      <Scrollbars
        autoHeight={true}
        autoHeightMax={'41.3vh'}
        autoHeightMin={'0px'}
        style={
          renderClients().length === 1
            ? {
              maxHeight: '38.3px',
            }
            : {}
        }
        renderTrackHorizontal={props => (
          <div
            {...props}
            className="track-horizontal"
            style={{ display: 'none' }}
          />
        )}
        renderThumbHorizontal={props => (
          <div
            {...props}
            className="thumb-horizontal"
            style={{ display: 'none' }}
          />
        )}
      >
        {renderClients()}
      </Scrollbars>
    )
  }
  return <></>
})

function ClientElement({ client, onClick, width }) {
  return (
    <>
      <ClientWrapper
        style={{ maxWidth: `${width}px` }}
        onClick={onClick(client)}
      >
        <ClientName>{`${client.name +
        ((client.city || client.phone) && client.name
          ? ','
          : '')}`}</ClientName>
        <Flex>
          <ClientDetails>{`${client.city +
          (client.phone && client.city ? `,` : '')}`}</ClientDetails>
          <ClientDetails>{client.phone}</ClientDetails>
        </Flex>
      </ClientWrapper>
      <Divider/>
    </>
  )
}

const ClientWrapper = styled.div`
  height: 38.3px;
  display: flex;
  padding: 3px 10px;
  flex-direction: column;
  justify-content: center;
  cursor: pointer;
  user-select: none;
  &:hover {
    background-color: ${(props: ITheme) => props.theme.colors.palette.greyTwo};
  }
`

const ClientName = styled.div`
  font-size: 13px;
  margin-right: 3px;
  white-space: nowrap;
  overflow: hidden;
  font-weight: 500;
  user-select: none;
  text-overflow: ellipsis;
`
const ClientDetails = styled.div`
  margin-right: 3px;
  font-size: 12px;
  opacity: 0.7;
  user-select: none;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`

export default ClientSearch
